import { css } from "@vitality-ds/system";
export default css({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end"
});